export default {
  "create-success": {
    EN: "Successfully created Product",
  },
  "create-failure": {
    EN: "Failed to create Product. Please try again later.",
  },
  "update-success": {
    EN: "Successfully updated Product",
  },
  "update-failure": {
    EN: "Failed to update Product. Please try again later.",
  },
  "delete-success": {
    EN: "Successfully deleted Product",
  },
  "delete-failure": {
    EN: "Failed to delete Product. Please try again later.",
  },
  "duplicate-success": {
    EN: "Product duplicated successfully",
  },
  "duplicate-failure": {
    EN: "Failed to duplicate Product. Please try again later",
  },
};
